import { render, staticRenderFns } from "./alert-block.vue?vue&type=template&id=7f573bab&"
import script from "./alert-block.vue?vue&type=script&lang=js&"
export * from "./alert-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports